.card {
  padding: var(--card-padding);
  border: 1px solid var(--color-border-card);
  background: var(--color-surface);
  backdrop-filter: blur(var(--glass-blur));
  -webkit-backdrop-filter: blur(var(--glass-blur));
  transition:
    border-color var(--duration-normal) ease,
    background-color var(--duration-normal) ease;
}

@media (hover: hover) and (pointer: fine) {
  .card:hover {
    border-color: var(--color-border-card-hover);
    background: rgb(15 15 18 / 48%);
  }
}
